import React from 'react'
import './../../assets/scss/meet.css'

function TableMeet() {
  return (
    <div>


<main className="st_viewport">
 
  <div className="st_wrap_table" data-table_id="0">
    <header className="st_table_header">
      <h2>Table header one</h2>
      <div className="st_row">
        <div className="st_column _rank">Date</div>
        <div className="st_column _name">Start Time</div>
        <div className="st_column _surname">Topic</div>
        <div className="st_column _year">Status</div>
        <div className="st_column _year"> --- </div>
        <div className="st_column _section">Link</div>
      </div>
    </header>
    <div className="st_table">
      <div className="st_row">
        <div className="st_column _rank">0</div>
        <div className="st_column _name">John</div>
        <div className="st_column _surname">Doe</div>
        <div className="st_column _year">1973</div>
        <div className="st_column _section">Germany</div>
      </div>
     
    </div>
  </div>




  
</main>
<footer>
  <pre>
    <code>
/**
 * Sticky Table Headers
 *
 * @author <a href="https://elementcode.de" tatget="_blank">Wolf Wortmann</a> &lt;https://elementcode.de&gt;
 * @license CC BY
 * @license https://creativecommons.org/licenses/by/4.0/
 */
    </code>
  </pre>
</footer>
      
    </div>
  )
}

export default TableMeet
